import BootstrapButton from "@/components/form/BootstrapButton"
import { showErrorMessage } from "@/composition/useLoading"
import { useVueAuth } from "oidc-vue"
import { ref } from "vue"
import { defineComponent, type ReactiveComponent } from "vue-utils"

const LoginButton: ReactiveComponent = () => {
	const loggingIn = ref(false)
	const { manager } = useVueAuth()

	async function logIn() {
		loggingIn.value = true

		try {
			await manager.signinRedirect()
		} catch (e) {
			console.error(e)

			if ((e as Error).message !== "Popup closed by user") {
				void showErrorMessage("Failed to log in", "Unable to log in. Try again later or contact an admin")
			}
		} finally {
			loggingIn.value = false
		}
	}

	return () => (
		<BootstrapButton color="primary" isSubmitting={loggingIn.value} onClick={() => void logIn()}>
			Log In or Register
		</BootstrapButton>
	)
}

export default defineComponent(LoginButton)
